import './cadastro.css';
import api from '../../../services/cle';
import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import Button from '../../../rxlib/components/buttons/button';
import InputLabel from '../../../rxlib/components/input-label';
import Redirecionar from '../../../rxlib/components/redirecionar';
import { tratarErroApi } from '../../../rxlib/services/utilitarios';
import UnidadeNegocioCadastro from '../../unidade-negocio/cadastro';
import UnidadeNegocioExclusao from '../../unidade-negocio/exclusao';
import { Listagem } from '../../../rxlib/components/layout/listagem';
import { ConfiguracoesTabela } from '../../../rxlib/components/table';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import ButtonsCrud from '../../../rxlib/components/buttons/buttons-crud';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { SelectLabel } from '../../../rxlib/components/select/select-label';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import { SelectLabelAsync } from '../../../rxlib/components/select/select-label-async';
import { ApiError, CadastroProps, Organizacao, OrganizacaoForm } from '../../../services/tipos';

const corTemaPadrao = 'Laranja';
const coresTema = [{ id: corTemaPadrao, nome: corTemaPadrao }];

function OrganizacaoCadastro(props: CadastroProps) {
    const [salvo, setSalvo] = useState<boolean>(false);
    const [logoFile, setLogoFile] = useState<File | null>(null);
    const [showDetail, setShowDetail] = useState<boolean>(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [tokenGerado, setTokenGerado] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [previewLogoUrl, setPreviewLogoUrl] = useState<string>('');
    const [unidadeNegocio, setUnidadeNegocio] = useState<[{}]>([{}]);
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [idUnidadeNegocio, setIdUnidadeNegocio] = useState<string>('');
    const [clickBotaoDetalhe, setClickBotaoDetalhe] = useState<boolean>(false);
    const [carregandoDetalhe, setCarregandoDetalhe] = useState<boolean>(false);
    const [showExclusaoDetail, setShowExclusaoDetail] = useState<boolean>(false);
    const [actionDetalhe, setActionDetalhe] = useState(props.match.params.action);
    const [atualizarListegemDetalhe, setAtualizarListegemDetalhe] = useState<boolean>(false);
    const [clickBotaoExclusaoDetalhe, setClickBotaoExclusaoDetalhe] = useState<boolean>(false);

    const [organizacao, setOrganizacao] = useState<OrganizacaoForm>({
        id: '',
        nome: '',
        tags: '',
        chave: '',
        sigla: '',
        token: '',
        logoUrl: '',
        corTema: corTemaPadrao,
    });

    const { register, handleSubmit } = useForm<OrganizacaoForm>();

    const handleHideDetail = () => setShowDetail(false);

    const handleHideWarning = () => setShowWarning(false);

    const handleHideExclusaoDetail = () => setShowExclusaoDetail(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Organizações e unidades', link: '/organizacao' },
        { texto: props.match.params.action ? 'Visualização' : props.match.params.id ? 'Edição' : 'Novo', link: '' },
    ];

    const configuracoesTabela: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Nome', campo: 'Nome', tipo: 'string' },
            { nome: 'Sigla', campo: 'Sigla', tipo: 'string' },
        ],
    }

    const temPermissao = props.match.params.action
        ? usuarioTemPermissao(token, 'organizacao_visualizar')
        : props.match.params.id
            ? usuarioTemPermissao(token, 'organizacao_editar')
            : usuarioTemPermissao(token, 'organizacao_novo');

    const podeVisualizarDetalhe = usuarioTemPermissao(token, 'unidade_visualizar');
    const podeVisualizarNoDetalhe = usuarioTemPermissao(token, 'unidade_visualizar') ? handleVisualizarDetalhe : undefined;
    const podeNovoNoDetalhe = !props.match.params.action ? usuarioTemPermissao(token, 'unidade_novo') ? handleNovoDetalhe : undefined : undefined;
    const podeEditarNoDetalhe = !props.match.params.action ? usuarioTemPermissao(token, 'unidade_editar') ? handleEditarDetalhe : undefined : undefined;
    const podeExcluirNoDetalhe = !props.match.params.action ? usuarioTemPermissao(token, 'unidade_excluir') ? handleExcluirDetalhe : undefined : undefined;

    useEffect(() => {
        if (temPermissao) {
            if (props.match.params.id) {
                Promise.all([
                    api.get(`/Organizacao/${props.match.params.id}`),
                    api.get(`/Organizacao/GerarUrlTemporaria/${props.match.params.id}`).catch(() => ({ data: '' }))
                ]).then(([organizacaoResponse, urlResponse]) => {
                    setOrganizacao({
                        id: organizacaoResponse.data.id,
                        nome: organizacaoResponse.data.nome,
                        chave: organizacaoResponse.data.chave,
                        sigla: organizacaoResponse.data.sigla,
                        token: organizacaoResponse.data.token,
                        logoUrl: organizacaoResponse.data.logoUrl ? organizacaoResponse.data.logoUrl : '',
                        corTema: organizacaoResponse.data.corTema ? organizacaoResponse.data.corTema : corTemaPadrao,
                        tags: organizacaoResponse.data.tags.join('|'),
                    });

                    if (urlResponse.data !== '') {
                        setPreviewLogoUrl(urlResponse.data);
                    } else {
                        setLogoFile(null);
                        setPreviewLogoUrl('');
                    }
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error, 'Não foi possível carregar a organização: ');
                });
            }
        }
    }, [props.match.params.id, temPermissao]);

    useEffect(() => {
        if ((temPermissao) && (podeVisualizarDetalhe)) {
            if (props.match.params.id) {
                setCarregandoDetalhe(true);
                api.get(`/OData/UnidadeNegocio?$filter=idOrganizacao eq ${props.match.params.id}`)
                    .then(response => {
                        setTimeout(() => {
                            setUnidadeNegocio(response.data.value);
                            setAtualizarListegemDetalhe(false);
                            setCarregandoDetalhe(false);
                        }, 250);
                    }).catch((error: AxiosError<ApiError>) => {
                        setCarregandoDetalhe(false);
                        setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                        setCarregandoDetalhe(true);
                    });
            }
        }
    }, [props.match.params.id, temPermissao, podeVisualizarDetalhe, atualizarListegemDetalhe]);

    const onSubmit: SubmitHandler<OrganizacaoForm> = data => {
        if (!clickBotaoDetalhe) {
            setCarregando(true);
        }

        const idOrganizacao = props.match.params.id
            ? data.id
            : data.id
                ? data.id
                : crypto.randomUUID();

        let organizacao: Organizacao = {
            id: idOrganizacao,
            nome: data.nome,
            chave: data.chave,
            sigla: data.sigla,
            token: data.token,
            logoUrl: props.match.params.id ? (organizacaoStateLogoUrl() ? organizacaoStateLogoUrl() : '') : '',
            corTema: data.corTema ? data.corTema : corTemaPadrao,
            tags: data.tags.split('|'),
        }

        setOrganizacao(organizacaoAtual => ({
            ...organizacaoAtual,
            id: idOrganizacao,
            nome: data.nome,
            chave: data.chave,
            sigla: data.sigla,
            token: data.token,
            corTema: data.corTema ? data.corTema : corTemaPadrao,
        }));

        if ((organizacao.tags) && (organizacao.tags.length === 1) && (organizacao.tags[0] === '')) {
            organizacao.tags = undefined;
        }

        props.match.params.id
            ? editar(organizacao)
            : salvar(organizacao);
    }

    function organizacaoStateLogoUrl(): string | undefined {
        return organizacao.logoUrl;
    }

    async function salvar(data: Organizacao) {
        api.post('/Organizacao', data)
            .then(async response => {
                const logoSincronizada = await sincronizarLogo(data.id);

                if (logoSincronizada) {
                    handleSalvar(false);
                }
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar a organização: ');
            });
    }

    async function editar(data: Organizacao) {
        api.put('/Organizacao', data)
            .then(async response => {
                const logoSincronizada = await sincronizarLogo(data.id);

                if (!logoSincronizada) {
                    return;
                }

                if (!clickBotaoDetalhe) {
                    handleSalvar(false);
                } else {
                    setCarregando(false);
                    setClickBotaoDetalhe(false);

                    if (clickBotaoExclusaoDetalhe) {
                        setShowExclusaoDetail(true);
                    } else {
                        setShowDetail(true);
                    }
                }
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar a organização: ');
            });
    }

    async function sincronizarLogo(idOrganizacao: string): Promise<boolean> {
        if (!logoFile) {
            return true;
        }

        const formData = new FormData();
        formData.append('arquivo', logoFile);

        try {
            const response = await api.post(`/Organizacao/${idOrganizacao}/logo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            setOrganizacao(organizacaoAtual => ({
                ...organizacaoAtual,
                id: idOrganizacao,
                logoUrl: response.data.logoUrl ? response.data.logoUrl : organizacaoAtual.logoUrl,
            }));
            setLogoFile(null);

            return true;
        } catch (error) {
            setCarregando(false);
            setOrganizacao(organizacaoAtual => ({
                ...organizacaoAtual,
                id: idOrganizacao,
            }));

            if (!props.match.params.id) {
                props.history.replace(`/organizacao/editar/${idOrganizacao}`);
            }

            tratarErro(error as AxiosError<ApiError>, 'A organização foi salva, mas não foi possível enviar a logo: ');
            return false;
        }
    }

    function tratarErro(error: AxiosError<ApiError>, mensagem: string) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, mensagem));
        setShowWarning(true);
    }

    function handleSalvar(acaoDetalheRealizada: boolean) {
        if (!acaoDetalheRealizada) {
            setSalvo(true);
        } else {
            setAtualizarListegemDetalhe(true);
        }
    }

    function handleNovoDetalhe() {
        setActionDetalhe(props.match.params.action);
        setClickBotaoExclusaoDetalhe(false);
        setClickBotaoDetalhe(true);
        setIdUnidadeNegocio('');
    }

    function handleEditarDetalhe(id: string) {
        setActionDetalhe(props.match.params.action);
        setClickBotaoExclusaoDetalhe(false);
        setClickBotaoDetalhe(true);
        setIdUnidadeNegocio(id);
    }

    function handleExcluirDetalhe(id: string) {
        setActionDetalhe(props.match.params.action);
        setClickBotaoExclusaoDetalhe(true);
        setClickBotaoDetalhe(true);
        setIdUnidadeNegocio(id);
    }

    function handleVisualizarDetalhe(id: string) {
        setClickBotaoExclusaoDetalhe(false);
        setClickBotaoDetalhe(true);
        setActionDetalhe('view');
        setIdUnidadeNegocio(id);
    }

    function handleGerar() {
        organizacao.token = '';
        setTokenGerado(false);
        setTimeout(() => {
            organizacao.token = crypto.randomUUID();
            setTokenGerado(true);
        }, 10);
    }

    function handleSelecionarLogo(event: any) {
        if ((event.target) && (event.target.files) && (event.target.files[0])) {
            const arquivo = event.target.files[0];
            setLogoFile(arquivo);
            setPreviewLogoUrl(URL.createObjectURL(arquivo));
        } else {
            setLogoFile(null);
        }
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <form onSubmit={handleSubmit(onSubmit)} className='rxlib-form'>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-12'>
                                <h6>{props.match.params.action ? 'Visualizar' : props.match.params.id ? 'Editar' : 'Nova'} organização</h6>
                            </div>
                        </div>
                        {
                            props.match.params.id
                                ? <div className='row px-1'>
                                    <div className='col-12 mt-1'>
                                        <InputLabel
                                            name='id'
                                            type='text'
                                            id='inputId'
                                            maxLength={50}
                                            readOnly={true}
                                            label='Código:'
                                            autoFocus={false}
                                            defaultValue={organizacao.id}
                                            placeholder='Código da organização'
                                            referencia={register({ required: true })} />
                                    </div>
                                </div>
                                : ''
                        }
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    name='nome'
                                    type='text'
                                    label='Nome:'
                                    id='inputNome'
                                    maxLength={100}
                                    autoFocus={true}
                                    defaultValue={organizacao.nome}
                                    placeholder='Nome da organização'
                                    referencia={register({ required: true })}
                                    readOnly={props.match.params.action === 'view'} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    name='chave'
                                    label='Chave:'
                                    maxLength={50}
                                    id='inputChave'
                                    autoFocus={false}
                                    defaultValue={organizacao.chave}
                                    placeholder='Chave da organização'
                                    referencia={register({ required: true })}
                                    readOnly={props.match.params.action === 'view'} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    name='sigla'
                                    maxLength={50}
                                    label='Sigla:'
                                    id='inputSigla'
                                    autoFocus={false}
                                    defaultValue={organizacao.sigla}
                                    placeholder='Sigla da organização'
                                    referencia={register({ required: true })}
                                    readOnly={props.match.params.action === 'view'} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                {
                                    props.match.params.action === 'view'
                                        ? <InputLabel
                                            type='text'
                                            name='logoUrl'
                                            maxLength={500}
                                            label='Logo:'
                                            id='inputLogoUrl'
                                            autoFocus={false}
                                            required={false}
                                            defaultValue={organizacao.logoUrl}
                                            placeholder='URL da imagem da logo'
                                            referencia={register({ required: false })}
                                            readOnly={true} />
                                        : <>
                                            <label htmlFor='inputLogoArquivo' className='form-label'>Logo:</label>
                                            <input
                                                accept='image/*'
                                                type='file'
                                                id='inputLogoArquivo'
                                                className='form-control rxlib-input-label-linha'
                                                onChange={handleSelecionarLogo} />
                                            {
                                                organizacao.logoUrl && !logoFile
                                                    ? <div className='organizacao-logo-helper'>A logo atual será mantida se nenhum novo arquivo for selecionado.</div>
                                                    : ''
                                            }
                                        </>
                                }
                            </div>
                        </div>
                        {
                            previewLogoUrl
                                ? <div className='row px-1'>
                                    <div className='col-12 mt-2 organizacao-logo-preview-cell'>
                                        <label className='form-label'>Pré-visualização do logo:</label>
                                        <img src={previewLogoUrl} alt='Logo da organização' className='organizacao-logo-preview' />
                                    </div>
                                </div>
                                : ''
                        }
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <SelectLabel
                                    foco='nao'
                                    name='corTema'
                                    itens={coresTema}
                                    id='inputCorTema'
                                    ariaLabel='CorTema'
                                    label='Cor do tema:'
                                    campoExibicaoRegistro='nome'
                                    campoIdentificadorRegistro='id'
                                    action={props.match.params.action}
                                    referencia={register({ required: true })}
                                    valorSelecionado={organizacao.corTema ? organizacao.corTema : corTemaPadrao} />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1 d-flex'>
                                <div className='organizacao-token-cell'>
                                    <InputLabel
                                        type='text'
                                        name='token'
                                        size='coluna'
                                        maxLength={50}
                                        label='Token:'
                                        id='inputToken'
                                        readOnly={true}
                                        autoFocus={tokenGerado}
                                        defaultValue={organizacao.token}
                                        placeholder='Token da organização'
                                        referencia={register({ required: true })} />
                                </div>
                                <div className='organizacao-token-cell'>
                                    <Button
                                        type='button'
                                        texto='Gerar'
                                        className='btn-gerar'
                                        onClick={handleGerar}
                                        classStyle='btn-rxlib' />
                                </div>
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <SelectLabelAsync
                                    foco='nao'
                                    type='Tag'
                                    name='tags'
                                    label='Tags:'
                                    required='nao'
                                    id='inputTags'
                                    isMulti={true}
                                    action={props.match.params.action}
                                    valorSelecionado={organizacao.tags}
                                    referencia={register({ required: false })} />
                            </div>
                        </div>
                        {
                            podeVisualizarDetalhe
                                ? <div className='row px-1'>
                                    <div className='col-12 mt-1'>
                                        <Listagem
                                            campoId='Id'
                                            descricao='Unidades'
                                            tipoBotaoAcao='submit'
                                            listagemDetalhe={true}
                                            onNovo={podeNovoNoDetalhe}
                                            fonteDados={unidadeNegocio}
                                            idEntidadePai={organizacao.id}
                                            carregando={carregandoDetalhe}
                                            onEditar={podeEditarNoDetalhe}
                                            onExcluir={podeExcluirNoDetalhe}
                                            onVisualizar={podeVisualizarNoDetalhe}
                                            configuracoesTabela={configuracoesTabela} />
                                    </div>
                                </div>
                                : ''
                        }
                        <ButtonsCrud
                            carregando={carregando}
                            styleButton='btn-rxlib'
                            linkCancelarVoltar='/organizacao'
                            visualizar={props.match.params.action === 'view'} />
                    </div>
                </form>
                <ModalWarning
                    show={showWarning}
                    message={messageWarning}
                    onHide={handleHideWarning} />
                <UnidadeNegocioCadastro
                    show={showDetail}
                    onSalvar={handleSalvar}
                    tratarErro={tratarErro}
                    onHide={handleHideDetail}
                    idOrganizacao={organizacao.id}
                    readOnly={actionDetalhe === 'view'}
                    idUnidadeNegocio={idUnidadeNegocio} />
                <UnidadeNegocioExclusao
                    tratarErro={tratarErro}
                    onExcluir={handleSalvar}
                    show={showExclusaoDetail}
                    onHide={handleHideExclusaoDetail}
                    idUnidadeNegocio={idUnidadeNegocio} />
                <AcessoBloqueado
                    permissao={temPermissao} />
                <Redirecionar
                    se={salvo}
                    para='/organizacao' />
            </RxlibLayout>
        </>
    );
}

export default OrganizacaoCadastro;